import { render, staticRenderFns } from "./ItemListTable.vue?vue&type=template&id=aa47216a&"
import script from "./ItemListTable.vue?vue&type=script&lang=js&"
export * from "./ItemListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports